import React from "react";
import {
    BrowserRouter as Router,
    Routes,
    Route,
    Navigate,
    useLocation,
} from "react-router-dom";
import Home from "./pages/Home";
import Karte from "./pages/Karte";
import Reservation from "./pages/Reservation";
import Order from "./pages/Order";
import Checkout from "./pages/Checkout";
import UeberUns from "./pages/UeberUns";
import Galerie from "./pages/Galerie";
import Feiern from "./pages/Feiern";
import Kontakt from "./pages/Kontakt";
import SiteLayout from "./components/site/SiteLayout";
import AdminLayout from "./admin/AdminLayout";
import LoginPage from "./admin/LoginPage";
import OrdersPage from "./admin/OrdersPage";
import ReservationsPage from "./admin/ReservationsPage";
import MenusPage from "./admin/MenusPage";
import SettingsPage from "./admin/SettingsPage";
import RequestsPage from "./admin/RequestsPage";
import GalleryPage from "./admin/GalleryPage";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";

const AppRoutes = () => {
    const { pathname } = useLocation();

    if (pathname === "/login") {
        return <LoginPage />;
    }

    if (pathname.startsWith("/admin")) {
        return (
            <AdminLayout>
                <Routes>
                    <Route path="/admin/bestellungen" element={<OrdersPage />} />
                    <Route path="/admin/reservierungen" element={<ReservationsPage />} />
                    <Route path="/admin/speisekarten" element={<MenusPage />} />
                    <Route path="/admin/einstellungen" element={<SettingsPage />} />
                    <Route path="/admin/anfragen" element={<RequestsPage />} />
                    <Route path="/admin/galerie" element={<GalleryPage />} />
                    {/* alte Popup-Seite und /admin selbst */}
                    <Route path="/admin/popups" element={<Navigate to="/admin/einstellungen" replace />} />
                    <Route path="*" element={<Navigate to="/admin/bestellungen" replace />} />
                </Routes>
            </AdminLayout>
        );
    }

    return (
        <SiteLayout>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/karte" element={<Karte />} />
                <Route path="/reservierung" element={<Reservation />} />
                <Route path="/bestellen" element={<Order />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/ueber-uns" element={<UeberUns />} />
                <Route path="/galerie" element={<Galerie />} />
                <Route path="/feiern" element={<Feiern />} />
                <Route path="/kontakt" element={<Kontakt />} />
                <Route path="/impressum" element={<Impressum />} />
                <Route path="/datenschutz" element={<Datenschutz />} />
                <Route path="*" element={<Home />} />
            </Routes>
        </SiteLayout>
    );
};

const App = () => (
    <Router>
        <AppRoutes />
    </Router>
);

export default App;
